var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:["header", _vm.visible ? "header--visible" : ""]},[_c('h1',{staticClass:"logo",style:(_vm.logoStyles),on:{"click":_vm.toHome}},[_vm._v("Moda Operandi")])])}
var staticRenderFns = []

export { render, staticRenderFns }